import { connect } from 'react-redux';
import PengajuanCuti from '../../../views/Personnel/Absensi/PengajuanCuti.absensi.view';
import { getAssignment } from '../../../states/thunks/personnel.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetAssignment: payload => dispatch(getAssignment(payload)),
  };
}
export default connect(null,mapDispatchToProps)(PengajuanCuti);